// Shared drag-source wiring for desktop weekly-grid cards.
//
// Both recipe cards (SlotCard) and entry cards (EntryCard — "note libre",
// dining, leftover, skip) must be draggable so any slot can be moved onto
// another. They previously duplicated this logic and drifted: EntryCard never
// got the drag wiring, so notes couldn't be dragged. Keep the drag payload in
// one place so every card type stays in lockstep.

// The dragstart handler puts the source slot key on the dataTransfer as
// 'text/plain'. SlotGrid's drop listeners read it back to know which slot was
// dragged (see SlotGrid handleDrop → onCardDrop(srcSk, targetSk)).
export function makeDragStart(sk: number, setDragging: (v: boolean) => void) {
  return (evt: Event) => {
    const e = evt as DragEvent;
    if (!e.dataTransfer) return;
    e.dataTransfer.setData('text/plain', String(sk));
    e.dataTransfer.effectAllowed = 'move';
    setDragging(true);
  };
}
